import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { customerPointSettingQueries } from '@/services/pointConfiguration/pointConfiguration.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useManageCustomerPointSettingStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('managePointSettingStatus', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: customerPointSettingQueries.all() });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isPending };
};

export default useManageCustomerPointSettingStatus;
